const getters = {
	origin: () => process.env.VUE_APP_SPACEIN_API_USERS_URL,
	pathPrefix: () => '/users-api'
}

const actions = {
	request({dispatch, getters}, data) {
		return dispatch('api/requests/sendAxiosRequest', {
			...data,
			url: getters.origin+getters.pathPrefix+data.url,
		}, {root: true});
	},

	getMe({ dispatch }) {
		return dispatch('request', {
			method: 'get',
			url: `/users/me`
		})
	},
	updateMe({ dispatch, rootGetters }, [firstName, lastName, pronouns, field1, field2, linkedInProfileUrl]) {
		return dispatch('request', {
			method: 'put',
			url: `/users/me`,
			data: {
				firstName, lastName, pronouns, field1, field2, linkedInProfileUrl,
				showTour: rootGetters['current_user/showTour']
			}
		})
	},
	deleteAvatar({ dispatch }) {
		return dispatch('request', {
			method: 'delete',
			url: `/users/me/avatar`
		})
	},
	updateShowTour({ dispatch, rootGetters }, showTour) {
		let data = Object.assign({}, rootGetters['current_user/data']);
		data.showTour = showTour;
		return dispatch('request', {
			method: 'put',
			url: `/users/me`,
			data
		})
	},
}

export default {
	namespaced: true,
	actions,
	getters
};
